import type { FC } from 'react';
import { useEffect } from 'react';
import cn from 'classnames';
import DaApp from '@wix/da-shared-react/pkg/DaApp';
import SiteHeader from '@wix/da-shared-react/pkg/SiteHeader';
import SiteFooter from '@wix/da-shared-react/pkg/SiteFooter';
import DrawerLoadable from '@wix/da-feedback-shared/pkg/Drawer/DrawerLoadable';
import FeedbackPageLoadable from '@wix/da-feedback-shared/pkg/FeedbackPage/FeedbackPageLoadable';
import { RuntimeEnvironment } from '@wix/da-shared-react/pkg/types';
import {
  ThemeOverride,
  ThemeOptions,
  ThemeSkin,
} from '@wix/da-react-context/pkg/ThemeContext';
import { submitModalRenderer } from '@wix/da-submit-shared/pkg/project-tools';
import Picker from '../Pages/Picker';
import { type PackagePickerStoreSlice } from '../../../redux/packagePicker/types';
import DamzPageLoadable from '@wix/da-damz-shared/pkg/components/DamzPage/DamzPageLoadable';
import DamzDrawerLoadable from '@wix/da-damz-shared/pkg/components/Drawer/DrawerLoadable';
import DamzGlobal from '@wix/da-damz-shared/pkg/redux/ModuleLoader';
import { composeModalRenderers } from '@wix/da-shared-react/pkg/Modals/helpers';
import { muroModalRenderer } from '@wix/da-muro-ui/pkg/project-tools';
import { damzModalRenderer } from '@wix/da-damz-shared/pkg/project-tools';

import s from './App.scss';

export interface Props {
  language: string;
  environment?: RuntimeEnvironment;
  pickerStep?: PackagePickerStoreSlice['pickerStep'];
  appMounted: (pageName: string) => void;
}

const App: FC<Props> = ({ language, environment, pickerStep, appMounted }) => {
  useEffect(() => {
    appMounted('package-picker');
  }, [appMounted]);

  const MainComponent = Picker;

  return (
    <DaApp
      language={language}
      environment={environment}
      bodyClassName={cn(s['body'], 'no-theme-skin')}
      theme={ThemeOptions.DARK}
      themeSkin={ThemeSkin.NONE}
      ncContextProps={{
        PageComponent: FeedbackPageLoadable,
        DrawerComponent: DrawerLoadable,
      }}
      damzContextProps={{
        GlobalComponent: DamzGlobal,
        DrawerComponent: DamzDrawerLoadable,
        PageComponent: DamzPageLoadable,
      }}
      modalsRenderFunc={composeModalRenderers(
        submitModalRenderer,
        muroModalRenderer,
        damzModalRenderer as any
      )}
    >
      <ThemeOverride theme={ThemeOptions.DARK} themeSkin={ThemeSkin.NONE}>
        <SiteHeader disableFixed minimalMode />
        <MainComponent />
        <SiteFooter />
      </ThemeOverride>
    </DaApp>
  );
};
App.displayName = 'PackagePickerApp';

export default App;
